export const EVENT_OPEN_SEARCH_DATES = 'open_search_dates';

export const triggerOpenSearchHeaderDates = () => {
  document.dispatchEvent(new CustomEvent(EVENT_OPEN_SEARCH_DATES));
};
